<template>
  <div class="text-center">
    <v-dialog persistent v-if="visible" v-model="visible" width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            {{ form.labels.titulo }}
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-form ref="form">
            <v-subheader inset class="ml-0 mt-3">
              <strong>Dados Pessoais</strong>
            </v-subheader>
            <v-row class="d-flex justify-center mt-2">
              <v-col cols="9">
                <v-text-field
                  id="nome"
                  v-model="content.nome"
                  label="Nome"
                  outlined
                  dense
                  disabled
                />
              </v-col>
              <v-col cols="3">
                <v-text-field
                  id="cpf"
                  v-model="content.cpf"
                  label="CPF"
                  v-mask="'###.###.###-##'"
                  outlined
                  dense
                  hide-details="auto"
                  disabled
                />
              </v-col>
            </v-row>
            <v-row class="d-flex justify-center">
              <v-col cols="8">
                <v-text-field
                  id="email"
                  label="E-mail"
                  v-model="content.email"
                  dense
                  outlined
                  hide-details="auto"
                  disabled
                />
              </v-col>
              <v-col cols="4">
                <v-text-field
                  id="telefone"
                  label="Telefone para contato"
                  v-model="content.telefone"
                  v-mask="'(##) #####-####'"
                  dense
                  outlined
                  hide-details="auto"
                  disabled
                />
              </v-col>
              <v-col :cols="content.possuiNomeSocial ? '6' : '12'">
                    <span class="mr-4">Possui nome social?</span>
                    <v-radio-group
                      v-model="content.possuiNomeSocial"
                      class="ml-4"
                      row
                      dense disabled>
                      <v-radio
                        label="Sim"
                        :value="true"
                      ></v-radio>
                      <v-radio
                        label="Não"
                        :value="false"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col cols="6" class="mt-7" v-if="content.possuiNomeSocial">
                    <v-text-field
                      v-model="content.nomeSocial"
                      label="Nome Social"
                      outlined
                      dense
                      maxlength="100"
                      counter="100"
                      disabled
                    ></v-text-field>
                  </v-col>
            </v-row>
            <v-subheader inset class="ml-0 mt-5">
              <strong>Formação Profissional</strong>
            </v-subheader>
            <v-row class="d-flex justify-center mt-2">
              <v-col cols="6">
                <v-text-field
                  id="grauEscolaridade"
                  label="Grau de Escolaridade"
                  v-model="content.escolaridade"
                  outlined
                  dense
                  disabled
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  id="localLotacao"
                  label="Local de Lotação"
                  v-model="content.lotacao"
                  outlined
                  dense
                  disabled
                />
              </v-col>
            </v-row>
            <v-row class="d-flex justify-center">
              <v-col cols="6">
                <v-text-field
                  id="funcaoPrograma"
                  label="Função no Programa"
                  v-model="content.funcao"
                  outlined
                  dense
                  disabled
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  id="municipio"
                  label="Município"
                  v-model="content.municipio"
                  outlined
                  dense
                  disabled
                />
              </v-col>
              <v-col :cols="content.possuiLotacaoDois ? '6' : '12'">
                <span class="mr-4">Possui outro local de lotação?</span>
                <v-radio-group
                  v-model="content.possuiLotacaoDois"
                  row
                  dense
                  disabled
                  class="ml-4">
                  <v-radio
                    label="Sim"
                    :value="true"
                  ></v-radio>
                  <v-radio
                    label="Não"
                    :value="false"
                  ></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="6">
              </v-col>
            </v-row>
            <v-row class="d-flex justify-center mt-2" v-if="content.possuiLotacaoDois">
              <v-col cols="6">
                <v-text-field
                class="mt-7"
                  :value="content.lotacaoDois"
                  label="Local de Lotação"
                  outlined
                  dense
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                class="mt-7"
                  :value="content.municipioDois"
                  label="Município"
                  outlined
                  dense
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-subheader inset class="ml-0 mt-5">
              <strong>Parecer</strong>
            </v-subheader>
            <v-row class="d-flex justify-center mt-2">
              <v-col cols="4">
                <v-autocomplete
                  label="Situação*"
                  :items="form.lists.listSituacoes"
                  :item-text="'descricao'"
                  :item-value="'id'"
                  v-model="content.situacao"
                  outlined
                  dense
                  return-object
                  :rules="[() => situacaoObrigatoria()]"
                />
              </v-col>
              <v-col cols="8">
                <v-autocomplete
                  v-if="situacaoAprovada"
                  id="perfilAcesso"
                  label="Perfil de acesso*"
                  :items="form.lists.listPerfilAcesso"
                  :item-text="'descricao'"
                  :item-value="'id'"
                  v-model="content.perfil"
                  outlined
                  dense
                  return-object
                  :rules="[(v) => $required(v)]"
                />
              </v-col>
            </v-row>
            <v-row class="d-flex justify-center">
              <v-col cols="12">
                <v-textarea
                  id="justificativa"
                  :label="`Justificativa${situacaoRecusada ? '*' : ''}`"
                  v-model="content.justificativa"
                  outlined
                  counter="2500"
                  maxlength="2500"
                  dense
                  hide-details="auto"
                  :rules="[(v) => $requiredIfTrue(v, situacaoRecusada)]"
                />
              </v-col>
            </v-row>
          </v-form>
          <sca-required-fields></sca-required-fields>
        </div>
        <sca-buttons
          @click="salvar()"
          @cancel="$emit('onClose')"
          :actionText="form.labels.submit"
        ></sca-buttons>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { SolicitacaoAcesso } from '~/commons/classes/solicitacao-acesso';
import SolicitacoesAcessoService from '~/services/solicitacoes-acesso.service';

export default {
  props: {
    ...new DialogProps(SolicitacaoAcesso),
    primeiroEnvio : {
      type: Boolean,
      default: false,
    },
  },
  mixins: [SolicitacoesAcessoService],
  data: () => ({
    form: {
      lists: {
        listPerfilAcesso: [],
        listSituacoes: [],
      },
      labels: {
        submit: "Salvar",
        titulo: "Solicitação de Acesso - Realizar Parecer",
      }
    },
  }),
  computed: {
    situacaoPendente() {
      return this.content.situacao.descricao.toLowerCase() === "pendente de aprovação";
    },
    situacaoRecusada() {
      return this.content.situacao.descricao.toLowerCase() === "recusado";
    },
    situacaoAprovada() {
      return this.content.situacao.descricao.toLowerCase() === "aprovado";
    },
  },
  methods: {
    initLabels() {
      if (!this.situacaoPendente) {
        this.form.labels.titulo = "Solicitação de Acesso - Editar Parecer";
        this.form.labels.submit = "Editar";
      } else {
        this.form.labels.titulo = "Solicitação de Acesso - Realizar Parecer";
        this.form.labels.submit = "Salvar";
      }
    },
    salvar() {
      const save = () => {
        return this.$swal({
          text: `Deseja confirmar o parecer da solicitação de acesso do profissional?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: `Confirmar`,
          cancelButtonText: `Cancelar`,
        }).then(() => {
          const payload = {
            situacaoId: this.content.situacao?.id,
            perfilId: this.content.perfil?.id,
            justificativa: this.content.justificativa,
            id: this.content.id,
          };
          return this.$editarSolicitacoesDeAcesso(payload, this.content.id);
        });
      };

      const enviarEmail = () => {
        return this.$swal({
          text: `Deseja enviar um e-mail de confirmação para o profissional?`,
          type: "question",
          showCancelButton: true,
          confirmButtonText: `Sim`,
          cancelButtonText: `Não`,
          allowOutsideClick: false,
        }).then(() => {
          const payloadEmail = {
            id: this.content.id,
            primeiroEnvio: this.primeiroEnvio,
          };
          return this.$envioDeEmailSolicitacoesDeAcesso(payloadEmail, this.content.id);
        });
      };
      if (this.$validarFormulario('Todos os campos obrigatórios devem ser preenchidos.')) {
        save()
          .then(({ data }) => {
            this.$notifySuccess(data.mensagem);
            enviarEmail()
              .then((resposta) => this.$notifySuccess(resposta.data.mensagem))
              .finally(() => {
                this.$emit("onClose");
                this.$emit("onSave");
              })
          })
      }
    },
    situacaoObrigatoria() {
      return this.situacaoRecusada || this.situacaoAprovada || 'Campo obrigatório';
    },
  },
  watch: {
    'content.situacao'() {
        this.$refs.form?.validate();
    },
    visible() {
      this.initLabels();
    },
  },
  mounted() {
    this.$buscarSituacoesSolicitacoesDeAcesso({ params: { atribuiveis: true } }).then(({ data }) => {
      this.form.lists.listSituacoes = data.itens;
    });
    this.$buscarPerfisSolicitacoesDeAcesso().then(({ data }) => {
      this.form.lists.listPerfilAcesso = data.itens;
    });
  },
};
</script>
